
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-optional-test-series",
      function () {
        return require("private-next-pages/upsc-optional-test-series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-optional-test-series"])
      });
    }
  